import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import * as React from 'react';
import { touch, WrappedFieldProps } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { getAutocompletePlacesSelectOptions } from 'logic/store/geolocation/geolocation.selectors';
import { geolocationSlice } from 'logic/store/geolocation/geolocation.slice';
import { FC } from 'react';
import {
  FormLocationTemplateInput,
  FormLocationSelectInputProps,
} from '../form-location-template-input/form-location-template-input';
import { PlaceSelectOptionValue } from 'logic/store/geolocation/geolocation.model';

const { Option } = Select;

export const FormLocationSearchTextInput: FC<WrappedFieldProps & FormLocationSelectInputProps> = ({
  meta,
  input,
  valuePlace,
  searchPlaces,
  onLocationContextChange,
  valueToDisplay,
  ...restProps
}) => {
  const dispatch = useDispatch();
  const options = useSelector(getAutocompletePlacesSelectOptions(valuePlace));

  const { value, onChange } = input;

  const handleOnSearch: SelectProps<any>['onSearch'] = (searchPhrase) => {
    dispatch(
      geolocationSlice.actions.fetchAutocompletePlaces({ searchPhrase, valuePlace, searchPlaces })
    );
  };

  const handleOnSelect: SelectProps<any>['onSelect'] = (_, option) => {
    const selectedValue = option.tag as PlaceSelectOptionValue;
    onChange(selectedValue.labelLong);
    onLocationContextChange && onLocationContextChange(selectedValue);
  };

  const handleBlur = () => meta.dispatch(touch(meta.form, input.name));

  const renderOptions = () =>
    options?.map((option, index) => {
      const isSelected = !!value.id && value.id === option?.value?.id;
      return (
        <Option
          key={index}
          value={option?.value?.id || ''}
          label={option?.value?.labelLong}
          tag={option?.value}
          className={isSelected ? 'ant-select-item-option-selected' : ''}
        >
          {option?.value?.labelLong}
        </Option>
      );
    });

  return (
    <FormLocationTemplateInput
      input={input}
      meta={meta}
      valueToDisplay={value}
      onSearch={handleOnSearch}
      onSelect={handleOnSelect}
      onBlur={handleBlur}
      valuePlace={valuePlace}
      searchPlaces={searchPlaces}
      options={renderOptions()}
      {...restProps}
    />
  );
};
